import { Box, HStack, Text } from "@chakra-ui/react";
import React from "react";
import {
  VerifiedUserIcon,
  WarningFillIcon,
  XmarkIcon,
} from "../../styles/icons";
import { CherryPayApi } from "../../api/models";

interface RiskRatingBadgeProps {
  riskLevel: CherryPayApi.CherryPassNotificationScheduleReviewRiskLevel;
}

interface RiskRatingConfig {
  label: string;
  icon: React.ComponentType<any>;
  bgColor: string;
  borderColor: string;
  iconColor: string;
}

const getRiskRatingConfig = (
  riskLevel: CherryPayApi.CherryPassNotificationScheduleReviewRiskLevel
): RiskRatingConfig => {
  switch (riskLevel) {
    case "NoRisk":
    case "LowRisk":
      return {
        label: "Safe",
        icon: VerifiedUserIcon,
        bgColor: "riskRating.safe.bg",
        borderColor: "riskRating.safe.border",
        iconColor: "riskRating.safe.icon",
      };
    case "MediumRisk":
      return {
        label: "Review Required",
        icon: WarningFillIcon,
        bgColor: "riskRating.reviewRequired.bg",
        borderColor: "riskRating.reviewRequired.border",
        iconColor: "riskRating.reviewRequired.icon",
      };
    case "HighRisk":
      return {
        label: "High Risk",
        icon: XmarkIcon,
        bgColor: "riskRating.highRisk.bg",
        borderColor: "riskRating.highRisk.border",
        iconColor: "riskRating.highRisk.icon",
      };
  }
};

export const RiskRatingBadge: React.FC<RiskRatingBadgeProps> = ({
  riskLevel,
}) => {
  const config = getRiskRatingConfig(riskLevel);
  const IconComponent = config.icon;

  return (
    <Box
      position="absolute"
      bottom="10px"
      right="10px"
      bg={config.bgColor}
      border="1px solid"
      borderColor={config.borderColor}
      borderRadius="20px"
      px={3}
      py={1.5}
      zIndex={1}
    >
      <HStack spacing={2}>
        <IconComponent color={config.iconColor} boxSize={4} />
        <Text fontSize="sm" fontWeight="medium" color="gray.700">
          {config.label}
        </Text>
      </HStack>
    </Box>
  );
};
